// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 629) return "static/css/629.f57179d058bd5e901e12.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "83971b4df2c901ec0bdb" + ".chunk.css";
};